import axios from "axios";
import {ADD_NEW_USER_SKILL, DELETE_USER_SKILL, UPDATE_USER_SKILL} from "./RestCatalog";

const addNewUserSkill = (payload) => {
    return axios.post(ADD_NEW_USER_SKILL, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const deleteUserSkill = (payload) => {
    return axios.post(DELETE_USER_SKILL, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const updateUserSkill = (payload) => {
    return axios.post(UPDATE_USER_SKILL, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

export { addNewUserSkill, deleteUserSkill, updateUserSkill };

